import { FC, useEffect, useState } from 'react';

import { useSecureJsonCollectionsStore } from '@/shared/lib/sj-orm/stores/secureJsonCollections.store';
import { useSyncQueueStore } from '@/shared/lib/sj-orm/synchronizer/sync-queue.store';

import { TabApi } from './Tabs/TabApi';
import { TabCollections } from './Tabs/TabCollections';
import { TabEnvList } from './Tabs/TabEnvList';
import { TabLogs } from './Tabs/TabLogs';
import { TabStores } from './Tabs/TabStores';
import { DebugButton } from './DebugButton';
import { isDebugToolsEnabled } from './helpers';
import { Container, Header, TabContainer, TabsStyled } from './styled';
import { useConsoleApi } from './useConsoleApi';

type Tabs = 'api' | 'collections' | 'envs' | 'logs' | 'stores';

const tabMap: Record<Tabs, FC> = {
  ['api']: TabApi,
  ['collections']: TabCollections,
  ['envs']: TabEnvList,
  ['logs']: TabLogs,
  ['stores']: TabStores,
};

const items = [
  { key: 'envs', label: 'env' },
  { key: 'collections', label: 'collections' },
  { key: 'stores', label: 'stores' },
  // { key: 'api', label: 'api' },
  // { key: 'logs', label: 'logs' },
];

export const DebugTools = () => {
  const sjcStore = useSecureJsonCollectionsStore();
  const syncQueueStore = useSyncQueueStore();
  const api = useConsoleApi();

  const [enabled, setEnabled] = useState(false);
  const [opened, setOpened] = useState(false);
  const [tab, setTab] = useState<Tabs>('envs');

  const handleChangTab = (key: string) => setTab(key as Tabs);

  useEffect(() => {
    if (isDebugToolsEnabled()) {
      setEnabled(true);
    }

    window._ = window._ ?? {
      ...api,
      toggle: () => setEnabled((s) => !s),
    };
  }, []);

  if (!enabled) {
    return null;
  }

  const TabItem = tabMap[tab];

  if (opened) {
    return (
      <Container>
        <Header>
          <DebugButton onClick={() => setOpened(false)} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <TabsStyled
              defaultActiveKey={tab}
              items={items}
              onChange={handleChangTab}
              style={{ height: 40 }}
            />
            <div>
              <span>ops/jobs: </span>
              <span>
                {sjcStore.operations.length} / {syncQueueStore.jobs.length}
              </span>
            </div>
          </div>
          <span onClick={() => setEnabled(false)}>hide</span>
        </Header>
        <TabContainer>
          <TabItem />
        </TabContainer>
      </Container>
    );
  } else {
    return <DebugButton onClick={() => setOpened(true)} />;
  }
};
